<template>
  <mdn-modal
    sm
    hideFooterStart
    v-if="isModalOpen"
    @close-modal="closeModal()"
    >
    <h1
      class="mdn-Heading mdn-Heading--md"
      slot="modal-header">
      Confirme sua escolha
    </h1>

    <div slot="modal-body">
      <div v-if="isDowngrade" class="flex flex-col justify-center items-center">
        <mdn-text id="downgrade">O plano escolhido é inferior ao seu plano atual. Você tem certeza que quer continuar?</mdn-text>
      </div>
      <div v-else class="flex flex-col gap-5 justify-center items-center">
        <div  class="flex flex-col rounded-xl border-2 border-gray-200 p-3">
          <mdn-heading :level="3">Claro Controle {{offer?.data.full}}GB</mdn-heading>
          <mdn-text>Valor do Plano R${{offer.price.adesao.full}}/mês</mdn-text>
        </div>
        <mdn-text>Deseja confirmar a troca de plano?</mdn-text>
      </div>
    </div>

    <div slot="modal-footer-end">
      <Button primary @click="handleConfirmSwitchOffer" >Sim, continuar</button>
      <Button secondary @click="handleBack">Voltar</button>
    </div>
  </mdn-modal>
</template>

<script>
import { MdnText, MdnModal, MdnHeading, Button } from 'mondrian-vue'
import { SMS_STORE_MSISDN_KEY } from '@/common/constants'
import { AcaoPermitidaParaPlanoEscolhidoEnum } from '../business/http/dto/ConfirmOTPResponse'
import { onlyNumbers } from '@brazilian-utils/helper-only-numbers'
import { NotifyUserActionsEnum } from '../business/http/dto/NotifyUserActionRequest'
import { singleOfferMixin } from '../business/offers/mixins'
import { loadUserDataMixin } from '../business/user/mixins'
import store from '../business/store'
import { serviceBuilder as userService } from '@/business/user/service'
import { useHttpServiceMixin } from '@/common/use-http'
import { isTestNumber } from '../common/utils'

export default {
  name: 'OfferSwitchModal',
  components: { MdnText, MdnModal, MdnHeading, Button },
  mixins: [
    loadUserDataMixin,
    singleOfferMixin,
    useHttpServiceMixin({ userService })
  ],
  data: () => ({ isModalOpen: false, isDowngrade: false }),
  methods: {
    async goToSwitchOrAdquirePage (userOfferSituation, msisdn) {
      const INVALID_CLIENT_STATE_ERROR_MESSAGE = 'Você não está em estado válido para migração ou troca de plano'

      switch (userOfferSituation) {
        case AcaoPermitidaParaPlanoEscolhidoEnum.TROCA: {
          try {
            const planoAtual = await this.$userService.fetchUserCurrentPlan(msisdn)
            const newOfferPrice = Number(`${this.offer.price.adesao.main}${this.offer.price.adesao.cents}` || 0)
            if (newOfferPrice < Number(planoAtual.valorPagamento)) {
              this.isDowngrade = true
            }
          } catch (e) {}
          this.isModalOpen = true
          break
        }
        case AcaoPermitidaParaPlanoEscolhidoEnum.ADESAO:
          this.$router.replace({ name: isTestNumber(msisdn) ? 'page-3-step-smartcheckout' : 'page-3-step' })
          break
        default:
          this.$router.replace({ name: 'page-error', params: { customMessage: INVALID_CLIENT_STATE_ERROR_MESSAGE } })
      }
    },
    async handleConfirmSwitchOffer () {
      try {
        await this.loadUserAndPlanSituation()
        const { userData, offerId } = this
        await this.$userService.switchOfferTo(offerId, onlyNumbers(userData.cpf), onlyNumbers(userData.msisdn))

        const smsMsisdn = await store.get(SMS_STORE_MSISDN_KEY)
        const extra = { offerId, cpf: onlyNumbers(userData.cpf), msisdn: onlyNumbers(userData.msisdn) }
        this.$userService.notifyUserAction(smsMsisdn, NotifyUserActionsEnum.TROCA_SUCESSO, extra)

        this.$router.replace({ name: 'page-success', params: { type: 'CHANGE_PLAN' } })
      } catch (err) {
        let customMessage = 'Algo de errado'
        try { customMessage = JSON.parse(err.metaData.body).message } catch (e) {}
        this.$router.replace({ name: 'page-error', params: { customMessage } })
      }
    },
    async handleBack () {
      await this.$router.replace({ name: 'page-1-step' })
    },
    closeModal () {
      this.isModalOpen = false
    }
  }
}
</script>
